
import { Component, Vue } from 'vue-property-decorator'
import EventBus from '@/helpers/EventBus'
import { fetchCart } from '@/api/Cart'
import store from '@/store/store'
import { TixTime } from '@/TixTime/TixTime'
import { API } from '@/api/API'
import { apiErrorMessage, logInTrackJS } from '@/errors/helpers'
import ExpiryTimer from '@/components/cart/ExpiryTimer.vue'
import type { TixTimeDuration } from '@/TixTime/Duration'
import { cartExpiresIn, cartExpiryAlertThreshold } from '@/state/Cart'
import type { LanguageStrings } from '@/language/types'

@Component({ name: 'ExtendCartTimerModal', components: { ExpiryTimer } })
export default class extends Vue {
  expiresIn: TixTimeDuration | null = null
  expiryInterval: ReturnType<typeof setTimeout>
  error: null | string = null
  t: LanguageStrings['extendCartTimerModal']

  created() {
    this.setExpiry()
    this.expiryInterval = setInterval(() => {
      const expiresInSeconds = this.expiresIn?.asSeconds() ?? 0
      // Ensures that all tabs close their modal instances,
      // preventing the user from extending the cart timer multiple times consecutively.
      if (expiresInSeconds > cartExpiryAlertThreshold || store.getters['Cart/declinedCartTimerExtension']) {
        this.$modals.close({ name: 'extend-cart-timer-modal' })
      } else {
        this.setExpiry()
      }
    }, 1000)
  }

  setExpiry() {
    this.expiresIn = cartExpiresIn()
  }

  destroyed() {
    clearInterval(this.expiryInterval)
  }

  dismiss() {
    store.commit('Cart/declinedCartTimerExtension', true)
    EventBus.$emit('close:modal')
  }

  confirm() {
    const cart = store.getters['Cart/cart']
    const extended = new TixTime(cart?.expires_at).add(2, 'minutes')
    return API.patch(`my/cart/${cart.id}`, {
      body: {
        expires_at: extended.format(),
      },
    })
      .then((response: any) => {
        const localExpiry = new TixTime().add(response.expires_in - 5, 'seconds').asTimeValue()
        store.commit('Cart/localExpiry', localExpiry)

        // The response from PATCH request does not contain the full CartApiResponse,
        // so we need a fetch here.
        return fetchCart(cart.id).then((response) => {
          store.commit('Cart/apiResponse', response)
          EventBus.$emit('close:modal:all')
        })
      })
      .catch((err) => {
        this.error = apiErrorMessage(err) as string
        logInTrackJS(this.error as string, { cartId: cart?.id })
      })
  }
}
